<template>
    <v-container>
        <v-toolbar dense flat color="transparent">
            <v-toolbar-title class="font-weight-bold"
                >System Settings</v-toolbar-title
            >
            <v-spacer></v-spacer>
            <v-btn @click="onSave()" color="primary" class="ml-2">Save</v-btn>
        </v-toolbar>
        <v-card>
            <v-form ref="configForm">
                <v-container>
                    <v-row>
                        <v-col col="12" md="6">
                            <v-card-text>
                                <div class="subtitle-1">Tool Weightage</div>
                            </v-card-text>
                        </v-col>
                        <v-col col="12" md="6">
                            <v-card-text>
                                <div class="subtitle-2">Feedback Tool</div>
                                <v-text-field
                                    v-model="
                                        config_transform.FEEDBACK_TOOL_WEIGHT
                                    "
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                ></v-text-field>
                            </v-card-text>

                            <v-card-text>
                                <div class="subtitle-2">Smiley Tool</div>
                                <v-text-field
                                    v-model="
                                        config_transform.SMILEY_TOOL_WEIGHT
                                    "
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                ></v-text-field>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col col="12" md="6">
                            <v-card-text>
                                <div class="subtitle-1">Score Category</div>
                            </v-card-text>
                        </v-col>
                        <v-col col="12" md="6">
                            <v-card-text>
                                <div class="subtitle-2">Excellent</div>
                                <v-text-field
                                    v-model="config_transform.EXCELLENT_SCORE"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                    prepend-inner-icon="mdi-greater-than-or-equal"
                                ></v-text-field>
                            </v-card-text>

                            <v-card-text>
                                <div class="subtitle-2">Good</div>
                                <v-text-field
                                    v-model="config_transform.GOOD_SCORE"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                    prepend-inner-icon="mdi-equal"
                                ></v-text-field>
                            </v-card-text>

                            <v-card-text>
                                <div class="subtitle-2">Average</div>
                                <v-text-field
                                    v-model="config_transform.AVERAGE_SCORE"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                    prepend-inner-icon="mdi-equal"
                                ></v-text-field>
                            </v-card-text>

                            <v-card-text>
                                <div class="subtitle-2">Poor</div>
                                <v-text-field
                                    v-model="config_transform.POOR_SCORE"
                                    required
                                    :rules="[(v) => !!v || 'This is required']"
                                    outlined
                                    hide-details="auto"
                                    dense
                                    type="number"
                                    prepend-inner-icon="mdi-less-than-or-equal"
                                ></v-text-field>
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider>
                </v-container>
            </v-form>
        </v-card>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            config: [],
            config_transform: {
                AVERAGE_SCORE: null,
                EXCELLENT_SCORE: null,
                FEEDBACK_TOOL_WEIGHT: null,
                GOOD_SCORE: null,
                POOR_SCORE: null,
                SMILEY_TOOL_WEIGHT: null,
            },
        };
    },
    computed: {},
    watch: {},
    created() {
        this.getListOfItems().then((data) => {
            this.config = data.items;
        });
    },
    watch: {
        config: function (val) {
            val.forEach((element) => {
                console.log(element);
                this.config_transform[element.key] = element.value;
            });
            console.log(this.config_transform);
        },
        "config_transform.FEEDBACK_TOOL_WEIGHT": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "FEEDBACK_TOOL_WEIGHT") {
                    this.config[index].value = val;
                }
            });
        },
        "config_transform.SMILEY_TOOL_WEIGHT": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "SMILEY_TOOL_WEIGHT") {
                    this.config[index].value = val;
                }
            });
        },
        "config_transform.EXCELLENT_SCORE": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "EXCELLENT_SCORE") {
                    this.config[index].value = val;
                }
            });
        },
        "config_transform.GOOD_SCORE": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "GOOD_SCORE") {
                    this.config[index].value = val;
                }
            });
        },
        "config_transform.AVERAGE_SCORE": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "AVERAGE_SCORE") {
                    this.config[index].value = val;
                }
            });
        },
        "config_transform.POOR_SCORE": function (val) {
            this.config.forEach((element, index, array) => {
                if (element.key == "POOR_SCORE") {
                    this.config[index].value = val;
                }
            });
        },
    },
    methods: {
        onSave: function () {
            if (this.$refs.configForm.validate()) {
                //TODO :- Perform action if the form is validated
                this.bulkUpdateConfig().then((res) => {
                    // this.items.push(res.data);
                });
            }
        },
        getListOfItems: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "get",
                    url: `/configs/?type=REPORT_CONFIG`,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let items = response.data.results;
                        resolve({
                            items,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
        bulkUpdateConfig: function () {
            return new Promise((resolve) => {
                this.$http({
                    method: "put",
                    url: `/configs/`,
                    data: this.config,
                })
                    .then(function (response) {
                        console.log(response.data);
                        let data = response.data;
                        resolve({
                            data,
                        });
                    })
                    .catch(function (err) {
                        console.log(err.response);
                    });
            });
        },
    },
};
</script>
